const question = {
    yes: { values: ['E', 'D'] },
    no: { values: ['P', 'E'] },
};

export default question;
